import {
  fetchEpisodeCreditsRequest,
  fetchPDHoursRequest,
  fetchTriennialSummaryRequest,
} from '@/requests';
import { Certificate, TriennialSummary } from '@/types';
import { camelCaseKeys } from '@/utils';

import { postgrestApi } from '../postgrest-api';
import { PostgrestApiTags } from '../store.constants';
import { transformCredit } from './tracker-pg-api.utils';

export const trackerPostgrestApi = postgrestApi.injectEndpoints({
  endpoints: builder => ({
    fetchCredits: builder.query<
      Certificate[],
      Parameters<typeof fetchPDHoursRequest>[0]
    >({
      query: fetchPDHoursRequest,
      transformResponse: (response: unknown[]) => response.map(transformCredit),
      providesTags: [PostgrestApiTags.PD_HOURS],
    }),
    fetchEpisodeCredits: builder.query<
      Certificate,
      Parameters<typeof fetchEpisodeCreditsRequest>[0]
    >({
      query: fetchEpisodeCreditsRequest,
      transformResponse: (response: unknown[]) =>
        response.map(transformCredit)[0],
    }),
    fetchTriennialSummary: builder.query<TriennialSummary, void>({
      query: fetchTriennialSummaryRequest,
      transformResponse: (response: any) =>
        camelCaseKeys(response) as TriennialSummary,
      providesTags: [PostgrestApiTags.TRIENNIAL_SUMMARY],
    }),
  }),
});

export const {
  useFetchCreditsQuery,
  useFetchEpisodeCreditsQuery,
  useFetchTriennialSummaryQuery,
} = trackerPostgrestApi;
